/**
 * Frontend date helpers — canonical format: YYYY-MM-DD
 * Accepts legacy MM-DD-YYYY from older data; normalizes on read.
 */

/** Any date value → YYYY-MM-DD (display / API) */
export function toDisplay(val) {
  return toInputValue(val);
}

/** Alias for toDisplay */
export function toISO(val) {
  return toInputValue(val);
}

/**
 * Any date format → YYYY-MM-DD
 * Handles MM-DD-YYYY, YYYY-MM-DD, ISO datetime
 */
export function toInputValue(display) {
  if (!display) return '';
  const s = display.toString().trim();

  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  if (/^\d{4}-\d{2}-\d{2}T/.test(s)) return s.slice(0, 10);

  if (/^\d{2}-\d{2}-\d{4}$/.test(s)) {
    const [m, d, y] = s.split('-');
    return `${y}-${m}-${d}`;
  }

  const part = s.slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(part)) return part;
  return part;
}

/** JS Date (local) → YYYY-MM-DD */
export function formatFromDate(d) {
  if (!d || isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function getToday() {
  return formatFromDate(new Date());
}

/** This week's Saturday (week ending) as YYYY-MM-DD */
export function getCurrentWeekEnding() {
  const today = new Date();
  const sat = new Date(today);
  sat.setDate(today.getDate() + (6 - today.getDay()));
  return formatFromDate(sat);
}

/** YYYY-MM-DD or legacy MM-DD-YYYY → local Date or null */
export function parseDate(val) {
  if (!val) return null;
  const iso = toInputValue(val);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return null;
  const [y, m, d] = iso.split('-');
  const dt = new Date(+y, +m - 1, +d);
  return isNaN(dt.getTime()) ? null : dt;
}

/**
 * Any date format → short day label e.g. "MON"
 */
export function getDayLabel(dateStr) {
  if (!dateStr) return '';
  const iso = toInputValue(dateStr);
  const date = new Date(`${iso}T00:00:00`);
  return ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'][date.getDay()] || '';
}

/** "08:00:00" or "08:00" → "8:00 AM" */
export function formatTime(t) {
  if (!t) return '';
  const [h, m] = t.split(':').map(Number);
  const ampm = h < 12 ? 'AM' : 'PM';
  const h12 = h % 12 || 12;
  return `${h12}:${String(m).padStart(2, '0')} ${ampm}`;
}
